import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["brandingColor", "onClick", "disabled", "hasBorder", "isTransparentOnHover", "buttonPaddingBlock", "buttonPaddingInline", "href", "external", "hideExternalLinkIcon", "children"];
import styled from 'styled-components';
import { filterProps } from 'foundations-components/utils/filterProps';
import { useMapTokenPropsToCSS } from 'foundations-components/hooks/useMapTokenPropsToCSS';
import { Button } from 'foundations-components/transitional/components/Button';
import { fwcBorderRadius } from 'foundations-theming/utils/fwc';
import { jsx as _jsx } from "react/jsx-runtime";
const ButtonContainer = styled.div.withConfig({
  displayName: "ButtonWithBranding__ButtonContainer"
})(({
  theme: _theme,
  $spaceCssStyles,
  brandingColor,
  disabled,
  hasBorder,
  isTransparentOnHover,
  buttonPaddingBlock,
  buttonPaddingInline
}) => {
  const theme = _theme;
  const elementStyle = Object.assign({
    color: brandingColor || theme.color['icon-core-subtle'],
    lineHeight: '16px',
    fontWeight: 500,
    paddingBlock: buttonPaddingBlock || '11px',
    paddingInline: buttonPaddingInline || '24px'
  }, disabled ? {
    cursor: 'not-allowed',
    color: '#b0c1d4'
  } : {});
  return Object.assign({
    display: 'flex',
    backgroundColor: theme.color['fill-surface-default'],
    opacity: 1,
    cursor: 'pointer',
    transition: 'all .15s ease-out'
  }, hasBorder ? {
    borderStyle: 'solid',
    borderWidth: theme.borderWidth[100],
    borderColor: brandingColor,
    borderRadius: theme.borderRadius[fwcBorderRadius('fwc-button')]
  } : {}, $spaceCssStyles, disabled ? {
    backgroundColor: theme.color['fill-primary-disabled'],
    borderColor: theme.color['temp-future-border-primary-disabled'],
    cursor: 'not-allowed'
  } : {}, isTransparentOnHover ? {
    ':hover': {
      opacity: 0.6
    }
  } : {}, {
    button: elementStyle,
    a: Object.assign({}, elementStyle, {
      '&:hover': {
        textDecoration: 'none',
        color: brandingColor || theme.color['icon-core-subtle']
      }
    })
  });
});
export const ButtonWithBranding = _ref => {
  let {
      brandingColor,
      onClick,
      disabled,
      hasBorder = true,
      isTransparentOnHover = true,
      buttonPaddingBlock,
      buttonPaddingInline,
      href,
      external,
      hideExternalLinkIcon,
      children
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    tokenProps
  } = filterProps(props);
  const spaceCssStyles = useMapTokenPropsToCSS(tokenProps);
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(ButtonContainer
    // spaceCssStyles are applied to container for extra margin/padding control
    , {
      $spaceCssStyles: spaceCssStyles,
      brandingColor: brandingColor,
      disabled: disabled,
      hasBorder: hasBorder,
      isTransparentOnHover: isTransparentOnHover,
      buttonPaddingBlock: buttonPaddingBlock,
      buttonPaddingInline: buttonPaddingInline,
      children: /*#__PURE__*/_jsx(Button, Object.assign({
        use: "unstyled",
        onClick: onClick,
        disabled: disabled,
        href: href,
        external: external,
        hideExternalLinkIcon: hideExternalLinkIcon
      }, domProps, {
        children: children
      }))
    })
  );
};